//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ForgotPassword',
    layout: 'guest',
    data() {
        return {
            email: '',
        };
    },
    head() {
        return {
            title: `Holi - ${this.$t('authentication.forgot_password')}`,
        };
    },
    methods: {
        onSubmit() {
            this.$axios
                .$post('/auth/forgot-password', { email: this.email })
                .then((res) => {
                    if (res.success === 1) {
                        setTimeout(() => {
                            this.$toast.add({
                                summary: {
                                    icon: require('~/assets/images/icons/accepted.svg'),
                                    message: `${this.$t('authentication.token_sent_to')} ${this.email}`,
                                },
                                life: 4000,
                            });
                        }, 500);

                        this.$router.push(this.localePath('/'));
                    } else {
                        this.$refs.form.setErrors(res.error);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
